import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import MobileAppRouter from "./routes/MobileAppRouter";
import { Toaster } from "react-hot-toast";

function isMobileDevice() {
  // 1. User Agent 기반 감지
  const uaCheck = /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // 2. 터치 이벤트 지원 여부 (태블릿 데스크탑 모드 감지)
  const touchCheck = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 3. 화면 크기 기반 감지 (태블릿 포함, 1024px 이하)
  const screenCheck = window.innerWidth <= 1024;

  // User Agent가 모바일이거나, 터치 지원 + 작은 화면이면 모바일로 판단
  return uaCheck || (touchCheck && screenCheck);
}

function App() {
  const host = window.location.host;
  const isMobileHost = host.startsWith("m.");
  const isDeviceMobile = isMobileDevice();

  const useMobileRouter = isMobileHost || isDeviceMobile;

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        containerStyle={{
          top: 72, // 헤더 아래
        }}
        toastOptions={{
          duration: 3000,
        }}
      />
      {useMobileRouter ? <MobileAppRouter /> : <AppRouter />}
    </BrowserRouter>
  );
}

export default App;

